import {   ReactNode,useEffect, useState,
} from 'react';

import { CircularProgressFullScreen } from '../../components/CircularProgressFullScreen/CircularProgressFullScreen';
import useLeadChannelStore from '../../store/leadChannelStore/useLeadChannelStore';
import useParameterStore from '../../store/parameterStore/useParameterStore';

const CmsGuard = ({ children }: { children: ReactNode }): ReactNode => {
  const { initLeadChannelFinished, initLeadChannel } = useLeadChannelStore();

  const [fetchingLeadChannel, setFetchingLeadChannel] = useState(true);

  const { leadChannelCode } = useParameterStore();

  useEffect((): void => {
    if (initLeadChannelFinished) {
      setFetchingLeadChannel(false);
      return;
    }

    initLeadChannel(leadChannelCode);
  }, [initLeadChannel, initLeadChannelFinished]);

  if (fetchingLeadChannel) {
    return <CircularProgressFullScreen />;
  }

  return children;
};

export default CmsGuard;
